module.exports = __webpack_public_path__ + "static/elder_tempest-297ec2d16cc90fe003e80ae00f19f93a.png";